export default __webpack_public_path__ + "static/media/learn.8b25c1ac.svg";